// apps/api/src/qxcircle/qxcircle-comment-seeds.ts
// Description: QXCircle comment bootstrap — empty on product; lab data in qxcircle-lab-fixtures.
// Owner: Masa Bayu
// Date: 2026-08-30

import type { QxCircleComment } from "./qxcircle.types";

export function seedQxCircleComments(): QxCircleComment[] {
  return [];
}
